var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _path43, _path44, _path45;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInviteNewUserError = function SvgInviteNewUserError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 349 330",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5398 117.582C81.4279 106.91 112.345 108.578 148.406 68.2581C215.847 -7.16833 302.91 -22.8681 335.55 94.2666C368.189 211.403 338.186 310.592 247.097 323.159C180.226 332.388 156.792 286.041 117.975 303.525C45.7001 336.058 -0.646452 292.99 0.00681712 224.551C0.660086 156.1 28.1093 131.774 58.5398 117.582Z",
    fill: "#EAF4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.373 130.561C264.029 133.798 252.211 127.215 248.969 115.868C245.738 104.521 252.318 92.7012 263.673 89.4716C275.028 86.2386 286.846 92.8187 290.077 104.171C293.296 115.517 286.716 127.335 275.373 130.561ZM323.239 129.208L327.04 114.094L319.379 110.322C319.403 108.106 319.26 105.873 318.963 103.631L326.494 99.6317L322.23 84.6481L312.799 85.2729C311.825 83.5494 310.744 81.8972 309.568 80.3235L314.521 72.3999L303.332 61.5556L294.971 67.1571C293.426 66.2401 291.835 65.4076 290.196 64.6617L290.54 54.7996L275.432 51L270.918 60.1778C269.161 60.1291 267.403 60.173 265.633 60.312L260.977 51.5476L245.987 55.814L246.652 65.7199C244.966 66.5823 243.362 67.5336 241.818 68.5646L233.741 63.519L222.897 74.7065L228.04 82.3819C226.876 84.122 225.831 85.9333 224.893 87.8076L216.139 87.5011L212.338 102.609L219.797 106.28C219.619 108.633 219.607 111.013 219.773 113.41L212.884 117.068L217.16 132.053L224.56 131.562C225.712 133.978 227.042 136.269 228.539 138.424L224.857 144.302L236.046 155.142L241.688 151.371C244.027 152.944 246.498 154.322 249.064 155.474L248.838 161.9L263.958 165.701L266.856 159.81C269.683 159.964 272.546 159.869 275.42 159.525L278.413 165.155L293.391 160.891L292.939 154.037C295.398 152.731 297.714 151.24 299.876 149.578L305.649 153.182L316.493 141.999L312.264 135.677C313.559 133.521 314.687 131.268 315.649 128.94L323.239 129.208Z",
    fill: "#FEC12F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M276.59 135.574C262.693 139.536 248.215 131.473 244.247 117.571C240.292 103.67 248.357 89.1851 262.254 85.2287C276.163 81.271 290.63 89.3359 294.597 103.237C298.552 117.139 290.487 131.617 276.59 135.574ZM260.377 78.639C242.834 83.6324 232.667 101.901 237.655 119.445C242.656 136.989 260.924 147.162 278.467 142.165C296.01 137.173 306.177 118.904 301.189 101.358C296.188 83.8141 277.92 73.6421 260.377 78.639Z",
    fill: "#FFAB01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.827 261.61C170.39 273.095 146.956 268.261 135.482 250.837C123.996 233.388 128.83 209.954 146.267 198.48C163.691 187.006 187.138 191.829 198.611 209.277C210.085 226.701 205.251 250.148 187.827 261.61ZM267.882 233.911L266.278 206.391L251.348 204.086C250.184 200.345 248.771 196.651 247.096 193.016L257.667 182.279L242.523 159.248L226.951 165.318C224.374 162.93 221.666 160.709 218.863 158.678L223.02 142.677L198.386 130.314L187.233 144.211C184.133 143.486 181.009 142.925 177.849 142.533L173.205 125.707L145.685 127.318L142.941 145.197C139.96 146.047 137.002 147.059 134.092 148.237L121.573 135.921L98.5543 151.073L104.921 167.432C102.557 169.784 100.336 172.242 98.2811 174.808L81.9732 170.58L69.6204 195.214L82.3651 205.44C81.3317 208.992 80.524 212.603 79.942 216.261L65 220.394L66.6153 247.903L81.1417 250.136C82.0919 254.198 83.3391 258.224 84.895 262.18L75.2147 272.014L90.3706 295.033L102.605 290.282C105.835 293.739 109.292 296.898 112.95 299.737L109.874 311.614L134.508 323.979L142.026 314.608C146.813 316.033 151.707 317.031 156.66 317.624L159.688 328.576L187.209 326.984L188.979 315.486C193.825 314.239 198.611 312.576 203.279 310.462L211.32 318.373L234.339 303.229L229.933 291.898C233.377 288.394 236.501 284.64 239.268 280.697L250.921 283.714L263.273 259.08L252.785 250.658C253.83 246.335 254.543 241.94 254.923 237.486L267.882 233.911Z",
    fill: "#9EADEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.595 268.71C171.227 282.773 142.519 276.858 128.468 255.502C114.393 234.146 120.32 205.414 141.676 191.363C163.044 177.3 191.752 183.227 205.803 204.583C219.878 225.939 213.951 254.647 192.595 268.71ZM135.012 181.232C108.062 198.977 100.591 235.204 118.324 262.166C136.069 289.116 172.308 296.575 199.258 278.842C226.209 261.097 233.68 224.87 215.935 197.92C198.189 170.958 161.963 163.498 135.012 181.232Z",
    fill: "#4A62C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.854 214.656H163.617V329.893H278.854V214.656Z",
    fill: "#92B400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.414 225.887H174.971V318.33H267.414V225.887Z",
    fill: "#9FC400"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328.637 237.95C328.637 240.575 326.499 242.701 323.886 242.701C321.261 242.701 319.135 240.575 319.135 237.95C319.135 235.325 321.261 233.211 323.886 233.211C326.499 233.211 328.637 235.325 328.637 237.95Z",
    fill: "#FFAB01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.525 175L304.776 194.265L320.039 213.555H259L274.263 194.265L289.525 175Z",
    fill: "#C5E1F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.633 223.664C218.633 223.664 255.061 223.735 269.124 223.949C278.852 224.104 279.731 210.23 275.895 208.14C264.243 201.797 227.897 198.543 227.897 198.543L203.168 221.253C203.168 221.253 204.558 221.205 218.633 223.664Z",
    fill: "#7038A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M252.92 149.464C252.92 149.464 262.291 146.839 266.365 159.061C272.625 177.827 272.066 195.05 271.199 198.72C270.796 200.407 269.596 206.239 259.132 206.464C254.891 206.559 256.59 197.461 256.59 197.461C256.59 197.461 253.87 189.741 250.972 176.675C248.062 163.61 252.92 149.464 252.92 149.464Z",
    fill: "#E91171"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.393 150.405L236.376 142.625L218.192 141.414L198.273 147.436C198.273 147.436 191.752 151.938 197.81 166.369C203.867 180.812 201.539 203.439 201.539 203.439L252.922 205.09C252.922 205.09 253.896 184.162 257.305 163.245C258.065 158.577 258.16 153.078 260.393 150.405Z",
    fill: "#E91171"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.089 204.037H227.714C230.445 183.845 230.327 163.011 227.298 142.879C226.514 143.354 225.73 143.817 224.934 144.292C225.599 164.876 224.471 185.46 225.089 204.037Z",
    fill: "#E91171"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M235.361 148.556C235.005 151.335 232.736 153.747 230.349 153.854H223.566C221.179 153.747 218.91 151.335 218.554 148.556C217.996 143.971 217.437 139.398 216.891 134.814C216.523 132.07 218.138 126.559 221.761 124.931C225.063 123.47 228.852 123.47 232.154 124.931C235.765 126.559 237.404 132.07 237.024 134.814C236.465 139.398 235.919 143.971 235.361 148.556Z",
    fill: "#E2C59C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.609 153.963L222.297 161.031L214.398 151.148L215.634 145.958L218.199 143.855L218.235 147.763L226.609 153.963Z",
    fill: "#E91171"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.215 154.011L231.515 161.078L238.867 151.873L237.667 146.231L235.826 143.855L235.078 148.476L227.215 154.011Z",
    fill: "#E91171"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.872 116.023C223.972 116.023 222.297 116.997 221.323 118.482H219.459C217.131 118.482 215.254 120.359 215.254 122.687V133.092H218.211V128.851C218.211 127.212 219.542 125.894 221.169 125.894H222.903H220.159H221.977C224.97 125.894 227.405 123.471 227.405 120.466V116.023H225.872Z",
    fill: "#7038A7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.623 136.861C220.623 138.287 219.47 139.439 218.045 139.439H217.831C216.406 139.439 215.254 138.287 215.254 136.861V133.738C215.254 132.324 216.406 131.16 217.831 131.16H218.045C219.09 131.16 220.005 131.801 220.409 132.692",
    fill: "#EC9568"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.555 120.157V116.023H232.463C235.48 116.023 237.903 118.458 237.903 121.452V125.585H228.971C225.978 125.585 223.555 123.15 223.555 120.157Z",
    fill: "#7038A7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.227 140.913C237.215 143.075 235.564 146.734 232.833 147.886C229.115 149.43 224.708 149.43 220.991 147.886C218.247 146.734 216.62 143.075 216.596 140.913V122.515C216.584 120.353 218.758 118.524 221.43 118.465H232.393C235.066 118.524 237.239 120.353 237.227 122.515V140.913Z",
    fill: "#F7B68B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.922 116.023C230.822 116.023 232.497 116.997 233.459 118.482H235.336C237.652 118.482 239.54 120.359 239.54 122.687V133.092H236.583V128.851C236.583 127.212 235.252 125.894 233.613 125.894H233.59H234.635H229.836C226.831 125.894 224.408 123.471 224.408 120.466V116.023H228.922Z",
    fill: "#7038A7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.295 133.738C234.295 132.312 235.459 131.16 236.872 131.16H237.098C238.511 131.16 239.676 132.312 239.676 133.738V136.861C239.676 138.287 238.511 139.439 237.098 139.439H236.872C235.827 139.439 234.925 138.809 234.521 137.907",
    fill: "#F7B68B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.435 121.214C224.495 120.869 224.53 120.513 224.53 120.157V116.023H220.694C217.677 116.023 215.254 118.458 215.254 121.452V125.585H219.102C219.482 125.585 219.862 125.537 220.207 125.466C220.646 123.34 222.309 121.665 224.435 121.214Z",
    fill: "#7038A7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M176.731 293.238C176.173 293.915 176.577 295.697 176.577 295.697C176.577 295.697 186.388 296.801 189.535 296.053C190.355 295.863 191.745 295.15 193.051 294.402C193.265 294.283 193.657 293.523 193.871 293.404C194.263 293.167 194.465 293.559 194.797 293.345C195.676 292.799 196.294 292.371 196.306 292.312C197.161 287.81 196.021 286.005 196.021 286.005C196.021 286.005 187.67 283.237 186.103 285.161C182.421 289.722 177.955 291.741 176.731 293.238Z",
    fill: "#161711"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M268.354 288.751L269.043 296.163L276.454 296.888C276.454 296.888 276.965 295.89 277.594 295.949C278.129 296.009 278.711 297.102 279.424 297.173C280.98 297.327 282.714 297.493 283.403 297.565C284.804 297.707 298.285 299.026 298.285 299.026C298.285 299.026 298.772 297.529 298.416 296.959C298.238 296.674 297.038 296.068 296.23 295.759C292.513 294.31 281.882 289.88 280.326 286.032C278.45 281.352 268.354 288.751 268.354 288.751Z",
    fill: "#161711"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M257.173 194.645L232.1 204.883C232.1 204.883 249.892 207.425 261.01 205.156C268.528 203.612 257.518 194.324 257.173 194.645Z",
    fill: "#F7B68B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M200.263 210.248C200.263 210.248 197.852 233.148 198.196 245.252C198.457 254.374 198.493 271.881 196.319 286.788C196.177 287.702 184.513 287.014 184.513 287.014C184.513 287.014 180.332 230.25 179.097 220.915C177.85 211.555 181.46 204.82 200.263 210.248Z",
    fill: "#7038A7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M273.621 215.741C273.621 215.741 269.868 221.68 259.558 223.081C255.84 223.592 265.568 289.525 265.568 289.525L280.795 284.643L277.849 211.727L273.621 215.741Z",
    fill: "#7038A7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M231.611 223.145C231.611 223.145 211.692 225.984 198.401 227.373C193.532 227.884 189.315 214.249 188.757 213.655C185.193 209.937 181.678 210.412 181.808 210.27C184.683 207.158 199.601 204.271 215.184 200.613C230.756 196.955 233.132 199.259 233.132 199.259L231.611 223.145Z",
    fill: "#7038A7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M215.184 200.615C199.601 204.273 184.683 207.16 181.808 210.272C181.678 210.414 185.193 209.939 188.757 213.657C188.899 213.823 189.802 218.194 190.443 219.762C187.901 215.177 224.52 202.278 232.443 198.94C230.958 198.453 226.646 197.919 215.184 200.615Z",
    fill: "#7038A7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M198.043 222.803L196.51 267.356L194.99 277.69L194.824 267.356L195.156 260.918L191.605 250.929L189.74 227.708L192.448 228.73L192.116 218.563L198.043 222.803Z",
    fill: "#7038A7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M273.096 210.262L276.825 211.283L278.179 264.804L270.388 283.951L274.117 270.909L272.597 243.97C272.597 243.97 267.169 257.012 267.169 256.335C267.169 255.658 271.742 228.042 271.742 228.042C271.742 228.042 266.658 232.283 267.169 232.117C267.68 231.95 270.221 212.804 273.096 210.262Z",
    fill: "#7038A7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.223 147.496C209.223 147.496 201.218 141.224 193.39 152.865C181.917 169.921 176.928 188.07 175.111 193.32C173.709 197.346 174.481 208.725 179.173 213.417C180.301 214.557 187.072 213.642 187.072 213.642L191.526 210.566L189.661 206.991L189.566 204.164C189.566 204.164 195.255 190.445 202.239 177.475C209.223 164.505 209.223 147.496 209.223 147.496Z",
    fill: "#E91171"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M189.655 200.009L215.643 201.363C215.643 201.363 190.605 212.849 189.786 210.865C185.094 199.653 189.655 200.009 189.655 200.009Z",
    fill: "#F7B68B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M203.998 199.279C205.518 198.555 205.376 198.543 205.376 198.543C205.376 198.543 206.777 200.194 208.785 200.502C209.782 200.657 213.001 200.692 213.001 200.692L217.788 200.811L220.009 200.692C220.009 200.692 221.268 200.526 221.601 200.74C222.563 201.358 221.743 201.856 221.743 201.856L213.156 203.068L221.399 204.101C221.399 204.101 222.432 204.398 222.48 204.956C222.527 205.479 222.183 205.467 222.183 205.467L212.609 206.489L216.814 207.486C216.814 207.486 217.812 207.819 217.883 208.365C217.978 208.948 218.014 209.114 218.014 209.114L209.212 208.258C209.212 208.258 202.489 200.016 203.998 199.279Z",
    fill: "#E9D6B8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M213.471 204.402L219.232 205.459C219.232 205.459 220.538 205.554 221.12 205.97C221.797 206.457 221.405 207.051 221.405 207.051L212.568 206.303L213.471 204.402Z",
    fill: "#E9D6B8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M249.601 209.019L249.624 208.971L249.601 207.332H198.408V209.019L198.586 209.327C199.453 210.753 201.009 211.002 202.815 211.002H245.194C246.988 211.002 248.555 210.753 249.423 209.327L249.601 209.019Z",
    fill: "#B6C2C9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240.973 207.82H207.074V208.984H240.973V207.82Z",
    fill: "#879BA6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M249.541 207.345L249.672 173.779C249.684 172.9 248.959 172.176 248.08 172.176H200.154C199.275 172.176 198.551 172.9 198.551 173.779L198.408 207.345H249.541Z",
    fill: "#E4EEF3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.202 189.924C227.19 191.635 225.789 193.024 224.078 193.024C222.368 193.024 220.99 191.635 220.99 189.924C221.002 188.214 222.392 186.824 224.114 186.824C225.824 186.824 227.202 188.214 227.202 189.924Z",
    fill: "#B6C2C9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M186.286 212.986L184.492 201.583L187.462 198.543L194.018 199.588L192.676 212.202L186.286 212.986Z",
    fill: "#E91171"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M265.943 204.824L266.62 200.631L258.33 193.172L253.828 195.203L259.696 206.439L265.943 204.824Z",
    fill: "#E91171"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 91.8308,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 63.6123,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6113,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.17,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.25,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.8906,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5293,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 91.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 97.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 103.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 108.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 114.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 63.6118,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.83,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.389,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.469,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.109,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 63.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 69.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 74.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 80.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.748,
    cy: 86.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M163.635 0C186.637 0 205.285 14.6983 205.285 32.8221C205.285 45.9244 195.507 57.2026 181.44 62.4679C181.716 63.03 181.965 63.6186 182.283 64.17C185.041 68.7831 189.07 72.2827 193.864 74.637C183.232 75.3953 173.396 72.2138 166.906 65.5168C165.825 65.5804 164.738 65.6494 163.635 65.6494C140.638 65.6494 122 50.9511 122 32.8221C122 14.6983 140.638 0 163.635 0Z",
    fill: "#FEC12F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.28 32.9148C205.222 45.9694 195.476 57.1946 181.44 62.4493C181.716 63.0114 181.965 63.6 182.283 64.1514C185.041 68.7645 189.07 72.2641 193.864 74.6184C183.232 75.3767 173.396 72.1952 166.906 65.4982C165.825 65.5618 164.738 65.6308 163.635 65.6308C140.68 65.6308 122.074 50.9908 122 32.9148H205.28Z",
    fill: "#FFAB01"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M160.808 19.8L161.996 36.684H166.388L167.576 19.8H160.808ZM160.808 42.768C160.808 43.656 161.12 44.4 161.744 45C162.392 45.576 163.208 45.864 164.192 45.864C165.176 45.864 165.98 45.576 166.604 45C167.252 44.4 167.576 43.656 167.576 42.768C167.576 41.832 167.252 41.088 166.604 40.536C165.98 39.96 165.176 39.672 164.192 39.672C163.208 39.672 162.392 39.96 161.744 40.536C161.12 41.088 160.808 41.832 160.808 42.768Z",
    fill: "#7038A7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteNewUserError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invite-new-user-error.55c9cf71.svg";
export { ForwardRef as ReactComponent };